import { ISessionState } from '~/src/dash/reducers/session-reducers';

export function getSessionPublisherId(session: ISessionState): number {
  let publisherId = 0;
  if (session.publisher && session.publisher.ID) {
    const parsedpublisherId = parseInt(session.publisher.ID, 10);
    if (!isNaN(parsedpublisherId)) {
      publisherId = parsedpublisherId;
    }
  }

  return publisherId;
}
